import React from 'react'

export const CloseIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <line x1="4" y1="4" x2="16" y2="16" stroke="currentColor" strokeWidth="2" />
    <line x1="16" y1="4" x2="4" y2="16" stroke="currentColor" strokeWidth="2" />
  </svg>
)
